import React, { useEffect, useState } from "react";

import estilo from "./styles/Portafolio.module.css";

import img0 from "../img/web/youtube.jpg";
import img1 from "../img/web/Twitch.jpg";
import img2 from "../img/web/ytanime.jpg";
import Titulo from "../components/Titulo";
import MetaDecorator from "../utils/MetaDecorator";

function Portafolio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [activar, setActivar] = useState(false);
  const [textoFiltro, setTextoFiltro] = useState("Todos");
  const [contenidoFiltro, setContenidoFiltro] = useState([]);

  let filtros = ["React", "Supabase", "Css", "Diseñó"];

  function filtro(e) {
    setTextoFiltro(e.currentTarget.dataset.value);
  }

  let portafolio = [
    {
      foto: img0,
      titulo: "Clon de YOUTUBE",
      descripcion:
        "Este proyecto es una réplica de YouTube con base de datos que permite subir, relizar busquedas, contar visualizaciones y cuenta con diseño responsivo.",
      tipo: "React Supabase",
      link: "https://redsocial-ross.000webhostapp.com/",
    },
    {
      foto: img1,
      titulo: "Clon de TWITCH",
      descripcion:
        "Mi proyecto consiste en una copia simple de Twitch utilizando HTML y CSS, la cual cuenta con diseño responsivo para adaptarse a cualquier dispositivo.",
      tipo: "Css",
      link: "https://ross1736.github.io/Perfil-Twitch/",
    },
    {
      foto: img2,
      titulo: "Página de ANIMES",
      descripcion:
        "Mi proyecto es una página simple de animes con una base de datos integrada usando Supabase y React. Además, utiliza servidores como FemBed, Stream SB, entre otros, para almacenar los videos.",
      tipo: "React Supabase",
      link: "https://ytanimetv.com/",
    },
  ];

  useEffect(() => {
    const filtrar = () => {
      setActivar(true);
      setTimeout(() => {
        if (textoFiltro === "Todos") {
          setContenidoFiltro(portafolio);
        } else {
          setContenidoFiltro(
            portafolio.filter((e) => e.tipo.includes(textoFiltro))
          );
        }
      }, 300);

      setTimeout(() => {
        setActivar(false);
      }, 500);
    };

    filtrar();
  }, [textoFiltro]);

  return (
    <div className={estilo.portafolio}>
      <MetaDecorator
        titulo={"Portafolio"}
        subtitulo={"Portafolio"}
        descripcion={
          "Bienvenido/a a mi página web, donde podrás conocer mi trabajo y experiencia a través de mi portafolio. En esta sección, encontrarás una selección cuidadosamente curada de mis proyectos más destacados, desde diseños gráficos y web hasta trabajos de ilustración y fotografía. Cada proyecto viene acompañado de una descripción detallada que te permitirá entender mi enfoque y proceso creativo, así como el resultado final obtenido. Mi objetivo es mostrar mi habilidad para resolver problemas de manera efectiva y creativa."
        }
        url={"https://bryanticonavalencia.site/portafolio"}
        canonical={"https://bryanticonavalencia.site/portafolio"}
      ></MetaDecorator>

      <Titulo
        titulo="Portafolio"
        descripcion="Ejemplos visuales de mi habilidad y creatividad en acción."
      ></Titulo>

      <div className={estilo.portafolio_contenedor}>
        <ul>
          <li
            data-value="Todos"
            onClick={filtro}
            className={textoFiltro === "Todos" ? estilo.activo : ""}
          >
            Todos
          </li>

          {filtros.map((e, i) => (
            <li
              key={i}
              onClick={filtro}
              data-value={e}
              className={textoFiltro === e ? estilo.activo : ""}
            >
              {e}
            </li>
          ))}
        </ul>

        {contenidoFiltro && (
          <div className={estilo.grid_portafolio}>
            {contenidoFiltro.map((e, i) => (
              <div
                key={i}
                className={
                  activar
                    ? `${estilo.tarjeta_portafolio}`
                    : `${estilo.tarjeta_portafolio} ${estilo.activar}`
                }
              >
                <div className={estilo.foto}>
                  <a
                    href={e.link === "" ? e.foto : e.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={e.foto} alt="foto" />
                  </a>
                </div>
                <h3>{e.titulo}</h3>
                <p>{e.descripcion}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default Portafolio;
